import type {
    GetContextDocumentUsage_contextDocumentUsage as ContextDocumentUsage,
    GetContextDocuments_contextDocuments as ContextDocument,
} from 'nutshell-graphql-types';

/**
 * Returns a string explaining the limit exceeded reason for the context document usage.
 * @param {?ContextDocumentUsage} contextDocumentUsage
 * @returns {?string} The limit exceeded reason string, or null if no limit is exceeded
 */
export const getLimitExceededReasonString = (
    contextDocumentUsage?: ContextDocumentUsage | null
): string | null | undefined => {
    if (!contextDocumentUsage) {
        return null;
    }

    const {limitExceededReason, wordsLimit, pagesLimit} = contextDocumentUsage;

    switch (limitExceededReason) {
        case 'PAGE_LIMIT':
            return `You have reached the ${pagesLimit.toLocaleString()} page limit for your context documents, please remove some documents to add more`;
        case 'WORD_LIMIT':
            return `You have reached the ${wordsLimit.toLocaleString()} word limit for your context documents, please remove or disable some documents to add more`;
        default:
            return null;
    }
};

export const sortByEffectiveStatus = (
    documents?: Array<ContextDocument | null | undefined>
): Array<ContextDocument | null | undefined> => {
    if (!documents) {
        return [];
    }

    return documents.sort((doc1?: ContextDocument | null, doc2?: ContextDocument | null) => {
        if (
            doc1 &&
            doc1.effectiveStatus === 'PENDING' &&
            doc2 &&
            doc2.effectiveStatus !== 'PENDING'
        ) {
            return -1;
        } else if (
            doc1 &&
            doc1.effectiveStatus !== 'PENDING' &&
            doc2 &&
            doc2.effectiveStatus === 'PENDING'
        ) {
            return 1;
        } else {
            return 0;
        }
    });
};
